import { Spinner } from "@blueprintjs/core";

export const LoadingPage = () => (
  <div className="loading-page">
    <Spinner className="loading-spinner" size={100} />
  </div>
);

export default LoadingPage;
